export const DELAY_NOTIFICATION = 10000;
export const DELAY_REDIRECT = 100;
export const COOKIE_NOTIFICATION_INTERVAL = 7 * 24 * 60 * 60 * 1000;
